import { Placement } from "@popperjs/core";
import React, { ReactNode, useState } from "react";
import ModalPrintable from "../modalPrintable/ModalPrintable";
import InfoCard from "./InfoCard";

interface IProps {
  popover?: string;
  popoverImage?: string;
  popoverPlacement?: Placement;
  label: string;
  htmlFor?: string;
  ismandatory?: boolean;
  errors?: string; 
  children?: ReactNode;
  popOnClickModal?: boolean;
  popOnClickModalData?: any;
  Id?:string;
  className?:string;
}

const Label: React.FC<IProps> = ({
  popover,
  popoverImage,
  popoverPlacement,
  label,
  htmlFor,
  ismandatory,
  errors,
  children,
  popOnClickModal,
  popOnClickModalData,
  Id,
  className
}) => {
  const handleHideModalPrintable = () => setShowModalPrintable(false);
  const [showModalPrintable, setShowModalPrintable] = useState(false);
  const handleShowModalPrintable = (e: { preventDefault: () => void; stopPropagation: () => void; }): void => {
    e.preventDefault();
    e.stopPropagation();
    //setContenuNom(CGU_CONTENU_NAME);
    setShowModalPrintable(true);
  };
  return (
    <>
      {
        <div className={"App-label-with-popover"}>
          {label && (
            <label htmlFor={htmlFor} className={`form-label ${className}`} id={Id ?? ""}>
              {label} {ismandatory && <em className="text-danger">*</em>}
            </label>
          )}
          {popOnClickModal && (
            <div onClick={handleShowModalPrintable}>
              <i className="bi-question-circle App-tooltip-image" />
            </div>
          )}
          {popover && (
            <InfoCard
              content={popover}
              image={popoverImage}
              placement={popoverPlacement}
            />
          )}
        </div>
      }
      {children}
      <div className="invalid-feedback d-flex justify-content-start">
        {errors && errors}
      </div>
      {showModalPrintable && (
        <ModalPrintable
          handleClose={handleHideModalPrintable}
          show={showModalPrintable}
          headerText={""}
          printbutton={false}
          modalsize="lg"
        >
          {popOnClickModalData}
        </ModalPrintable>
      )}
    </>
  );
};

export default Label;
